import {Spin} from "antd";
import React from "react";
import styled from "styled-components";

const SpinContainer = styled.div`
  text-align: center;
  padding: 30px 50px;
  margin-top: 30px;
`
export const Spinner = () => (
    <SpinContainer>
        <Spin size="large" key={"spinner"}/>
    </SpinContainer>
)

export const withLoader = (Component, data) => (props) =>
    {
        const newProps = {...props, data}
        return <Component {...newProps}/>
    }

export const DataSpinner = (props) => {
    const {children, ...other} = props
    return (props.data ? props.Children(other) : <Spinner/>);
}
